<script>
  import CodeSnippet from '../components/CodeSnippet.svelte';

  const snippet = `
    <div class="accordion">
      <div class="accordion-item w-full overflow-hidden">
        <input
          class="absolute opacity-0"
          id="accordion-item-single-one"
          type="checkbox"
          name="accordion-item-single" />
        <label
          class="block p-4 w-full bg-transparent cursor-pointer"
          for="accordion-item-single-one">
          <div class="flex items-center flex-no-wrap">
            <div class="border-box flex-grow-0 w-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="mr-3 align-middle">
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <path
                    d="M6.758 2.985c-2.012.738-3.16 2.107-3.16
                    4.283a.5.5 0 101 0c0-1.717.858-2.74 2.505-3.345a.5.5
                    0 00-.345-.938z"
                    class="fill-current" />
                  <path
                    d="M5.083.487A6.667 6.667 0 00.816 6.65a12.659
                    12.659 0 002.6
                    6.844c.225.286.271.668.124.995-.36.81-.828 3.17-.896
                    4.982-.105 2.738.566 4.497 2.37 4.497 1.307 0
                    1.792-.695
                    2.252-2.419l.132-.495c.05-.188.096-.344.143-.493.583-1.858
                    1.588-2.707 4.058-2.707h.824c2.477 0 3.48.848 4.058
                    2.706.046.147.09.303.14.489l.13.492c.457 1.73.941
                    2.427 2.256 2.427 1.806 0 2.478-1.758
                    2.376-4.495-.068-1.812-.535-4.173-.895-4.982a.966.966
                    0 01.123-.993l.004-.004a12.64 12.64 0
                    002.6-6.803C23.19 3.914 21.498 1.47 18.947.487a6.668
                    6.668 0 00-6.933 1.331A6.668 6.668 0
                    005.083.488zm14.492 14.41c.302.68.745 2.919.808
                    4.612.084 2.226-.387 3.458-1.376 3.458-.693
                    0-.938-.353-1.289-1.682-.242-.918-.196-.747-.282-1.023-.7-2.253-2.068-3.409-5.013-3.409H11.6c-2.937
                    0-4.305 1.156-5.012
                    3.408-.051.162-.1.33-.154.53-.032.116-.14.526-.133.5-.353
                    1.323-.6 1.676-1.285 1.676-.987
                    0-1.457-1.233-1.372-3.459.064-1.693.508-3.932.81-4.611.299-.665.204-1.443-.247-2.018a11.637
                    11.637 0 01-2.392-6.262c.022-2.284 1.46-4.36
                    3.629-5.197a5.667 5.667 0 016.205 1.445.5.5 0 00.735
                    0 5.667 5.667 0 019.833 3.793 11.623 11.623 0
                    01-2.391 6.222 1.965 1.965 0 00-.25 2.018z"
                    class="fill-current" />
                </g>
              </svg>
            </div>
            <div class="border-box flex-grow w-auto max-w-full">
              <h4 class="heading heading-4">
                Choose your Extras provider
              </h4>
              <div class="font-semibold copy-small m-0">Optional subtitle.</div>
            </div>
            <div class="border-box flex-grow-0 w-auto pl-5">
              <div class="dropdown">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24">
                  <path
                    d="M11.902 16.65L1.282 6.03a.75.75 0 00-1.06
                    1.06l11.15 11.15a.75.75 0 001.06
                    0l11.15-11.15a.75.75 0 00-1.06-1.06l-10.62 10.62z"
                    class="fill-current" />
                </svg>
              </div>
            </div>
          </div>
        </label>
        <div class="accordion-item-content">
          <div class="p-4">
            For Extras like dental and physio, see any provider with
            professional qualifications recognised by nib.
          </div>
        </div>
      </div>
      <div class="accordion-item w-full overflow-hidden">
        <input
          class="absolute opacity-0"
          id="accordion-item-single-two"
          type="checkbox"
          name="accordion-item-single" />
        <label
          class="block p-4 w-full bg-transparent cursor-pointer"
          for="accordion-item-single-two">
          <div class="flex items-center flex-no-wrap">
            <div class="border-box flex-grow-0 w-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="mr-3 align-middle">
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <g class="fill-current" fill-rule="nonzero">
                    <path
                      d="M11.39 8.336l5.018 4.451a.5.5 0
                      00.664-.748l-5.02-4.451a.5.5 0 00-.663.748zM15.565
                      6.66l5.02 4.451a.5.5 0
                      00.663-.748l-5.02-4.451a.5.5 0 00-.663.748z" />
                    <path
                      d="M20.467 2.423l-2.943 5.459a.5.5 0
                      10.88.474l2.943-5.459a.5.5 0 10-.88-.474z" />
                    <path
                      d="M15.25 6.009l-3.82 1.533a.5.5 0
                      10.372.928l4.284-1.72a.5.5 0
                      00.278-.65l-.561-1.393A2.5 2.5 0 1120.44
                      2.84l2.237 5.574a1 1 0 01-.556 1.3L11.744
                      13.88a.5.5 0 00.372.928l10.378-4.165a2 2 0
                      001.112-2.601l-2.235-5.568a3.5 3.5 0 10-6.493
                      2.613l.371.922zM.964 19.202l6.114-2.892a.5.5 0
                      00-.428-.904L.536 18.298a.5.5 0 00.428.904zM6.956
                      9.852L.623 11.516a.5.5 0 00.254.968L7.21
                      10.82a.5.5 0 00-.254-.968zM.75 23.75h21a2 2 0
                      002-2v-5.313a1.936 1.936 0 00-3.597-.996l-1.395
                      2.324a1 1 0 01-.857.485H11.25a.5.5 0 100 1h6.651a2
                      2 0 001.715-.97l1.395-2.325a.936.936 0
                      011.739.482v5.313a1 1 0 01-1 1h-21a.5.5 0 100 1z" />
                  </g>
                  <path
                    d="M10.75.775l.7 13.958a1 1 0 01-.604.968l-2.1.9a1 1
                    0 01-1.392-.962L8 .772a.5.5 0 00-1-.044l-.646
                    14.867a2 2 0 002.786 1.926l2.1-.9a2 2 0
                    001.21-1.938L11.75.725a.5.5 0 00-1 .05z"
                    class="fill-current" />
                </g>
              </svg>
            </div>
            <div class="border-box flex-grow w-auto max-w-full">
              <h4 class="heading heading-4">
                Accidental Injury Benefit
              </h4>
              <div class="font-semibold copy-small m-0">Optional subtitle.</div>
            </div>
            <div class="border-box flex-grow-0 w-auto pl-5">
              <div class="dropdown">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24">
                  <path
                    d="M11.902 16.65L1.282 6.03a.75.75 0 00-1.06
                    1.06l11.15 11.15a.75.75 0 001.06
                    0l11.15-11.15a.75.75 0 00-1.06-1.06l-10.62 10.62z"
                    class="fill-current" />
                </svg>
              </div>
            </div>
          </div>
        </label>
        <div class="accordion-item-content">
          <div class="p-4">
            Seek treatment at a hospital Emergency Department within 24
            hours of an accident & if you need to be admitted, you'll
            receive benefits in line with our top hospital cover for the
            next 90 days.
          </div>
        </div>
      </div>
      <div class="accordion-item w-full overflow-hidden">
        <input
          class="absolute opacity-0"
          id="accordion-item-single-three"
          type="checkbox"
          name="accordion-item-single" />
        <label
          class="block p-4 w-full bg-transparent cursor-pointer"
          for="accordion-item-single-three">
          <div class="flex items-center flex-no-wrap">
            <div class="border-box flex-grow-0 w-auto">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                class="mr-3 align-middle">
                <g fill="none" fill-rule="evenodd">
                  <path d="M0 0h24v24H0z" />
                  <g class="fill-current" fill-rule="nonzero">
                    <path
                      d="M8.703 16.496V7.402c0-.561.454-1.016
                      1.015-1.016h12.127c.56 0 1.015.455 1.015
                      1.016v10.61c0 .561-.454 1.016-1.015
                      1.016h-.888a.5.5 0 100 1h.888a2.016 2.016 0
                      002.015-2.016V7.402a2.016 2.016 0
                      00-2.015-2.016H9.718a2.016 2.016 0 00-2.015
                      2.016v9.094a.5.5 0 101 0z" />
                    <path
                      d="M2.443 10.893l-1.422.948c-.56.373-.896 1-.897
                      1.673v4.498c0 1.113.902 2.016 2.015 2.016H5.3a.5.5
                      0 100-1H2.14a1.016 1.016 0
                      01-1.016-1.016v-4.497c0-.338.17-.654.452-.842l1.599-1.066a.5.5
                      0
                      00.215-.328l.47-2.642c.106-.418.513-.735.979-.735h2.864v8.724a.5.5
                      0 101 0V7.402a.5.5 0 00-.5-.5H4.839c-.925
                      0-1.731.629-1.956 1.526l-.44 2.465z" />
                    <path
                      d="M7.445 21.544a2.774 2.774 0 100-5.548 2.774
                      2.774 0 000 5.548zm0-1a1.774 1.774 0 110-3.548
                      1.774 1.774 0 010 3.548zM18.813 21.544a2.774 2.774
                      0 100-5.548 2.774 2.774 0 000 5.548zm0-1a1.774
                      1.774 0 110-3.548 1.774 1.774 0 010 3.548z" />
                    <path
                      d="M9.589 20.028h7.08a.5.5 0 100-1h-7.08a.5.5 0
                      000 1zM17.04 5.128a2.774 2.774 0 10-5.548
                      0v.758a.5.5 0 00.5.5h4.547a.5.5 0
                      00.5-.5v-.758zm-4.548.258v-.258a1.774 1.774 0
                      013.547 0v.258h-3.547z" />
                  </g>
                  <path
                    d="M15.782 9.175a.5.5 0 01.5.5l-.001
                    1.773h1.774a.5.5 0 01.492.411l.008.09a.5.5 0
                    01-.5.5h-1.774v1.774a.5.5 0 01-.41.492l-.09.008a.5.5
                    0 01-.5-.5v-1.775h-1.773a.5.5 0
                    01-.492-.41l-.008-.09a.5.5 0
                    01.5-.5h1.773V9.675a.5.5 0 01.41-.492z"
                    class="fill-current" />
                </g>
              </svg>
            </div>
            <div class="border-box flex-grow w-auto max-w-full">
              <h4 class="heading heading-4">Emergency Ambulance</h4>
              <div class="font-semibold copy-small m-0">Optional subtitle.</div>
            </div>
            <div class="border-box flex-grow-0 w-auto pl-5">
              <div class="dropdown">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24">
                  <path
                    d="M11.902 16.65L1.282 6.03a.75.75 0 00-1.06
                    1.06l11.15 11.15a.75.75 0 001.06
                    0l11.15-11.15a.75.75 0 00-1.06-1.06l-10.62 10.62z"
                    class="fill-current" />
                </svg>
              </div>
            </div>
          </div>
        </label>
        <div class="accordion-item-content">
          <div class="p-4">
            No annual limits on Emergency Ambulance transportation -
            excludes residents of QLD and TAS who have ambulance
            services provided by their State Ambulance Schemes.
          </div>
        </div>
      </div>
    </div>
  `;
</script>

<template>
  <section id="section" class="page-section bg-warmWhite20">
    <div class="container">
      <h2 class="heading heading-2 my-6">Accordion</h2>
      {@html snippet}
      <CodeSnippet id="accordion" {snippet} />
    </div>
  </section>
</template>
